import { useGetMomentsFeatureFlagsForSelfQuery } from '@/store/api/momentsApi';

export const MCP_MEMBER_FLAG = 'mcp+member';

export interface UseMcpMemberFlagOptions {
  skip?: boolean;
}

export interface McpMemberFlagState {
  enabled: boolean;
  isLoading: boolean;
}

// Login and logout reset the whole API cache (authApi loginUser/logoutUser),
// so a same-argument background refetch can only re-confirm this person's
// flags. Keeping the answer while it runs stops flagged pages from unmounting
// mid-edit; a failed request turns the feature off.
export const useMcpMemberFlag = ({
  skip = false,
}: UseMcpMemberFlagOptions = {}): McpMemberFlagState => {
  const { currentData, isError, isFetching, isLoading } =
    useGetMomentsFeatureFlagsForSelfQuery(undefined, { skip });
  if (skip) {
    return { enabled: false, isLoading: false };
  }
  const loading = isLoading || (isFetching && currentData === undefined);
  const flags = currentData?.flags;
  const enabled =
    !loading && !isError && Array.isArray(flags)
      ? flags.includes(MCP_MEMBER_FLAG)
      : false;
  return { enabled, isLoading: loading };
};
